import React from 'react';
import styled from 'styled-components';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import LoadingSpinner from '@grnhse/seedling/lib/birch/components/loading_spinner';
import AiMagicIcon from '@grnhse/seedling/lib/birch/icons/ai_magic';
import {
  SectionTitle,
  Label,
  SecondaryBody,
} from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { withLocalePrefix } from 'shared/utils/translation';
import type { MatchNarrative as MatchNarrativeType } from 'talent_matching/types';
import { useMatchNarrative } from 'talent_matching/my_greenhouse/hooks/use_match_narrative';

const t = withLocalePrefix('talent_matching.match_narrative');

const ButtonWrapper = styled.div`
  button {
    padding-left: 0;
  }
`;

const NarrativeContent = ({ narrative }: { narrative: MatchNarrativeType }) => (
  <Stack spacing={1.5} sx={{ padding: 0 }}>
    <SectionTitle>{t('title')}</SectionTitle>
    {narrative.summary && (
      <SecondaryBody className="pii-blur">{narrative.summary}</SecondaryBody>
    )}
    {narrative.sections.map((section) => (
      <Stack key={section.heading} spacing={0.5} sx={{ padding: 0 }}>
        <Label>{section.heading}</Label>
        <SecondaryBody className="pii-blur">{section.body}</SecondaryBody>
      </Stack>
    ))}
  </Stack>
);

const MatchNarrativeSection = ({
  candidateId,
}: {
  candidateId: number | string;
}) => {
  const { enabled, narrative, request, isLoading } =
    useMatchNarrative(candidateId);

  if (!enabled) {
    return null;
  }
  if (narrative) {
    return <NarrativeContent narrative={narrative} />;
  }

  return (
    <ButtonWrapper>
      <Stack direction="row" spacing={1} alignItems="center">
        <TertiaryButton
          onClick={request}
          disabled={isLoading}
          size="md"
          icon={AiMagicIcon}
        >
          {t('cta')}
        </TertiaryButton>
        {isLoading && <LoadingSpinner size="small" aria-label={t('loading')} />}
      </Stack>
    </ButtonWrapper>
  );
};

export default MatchNarrativeSection;
